import React, { useContext, useEffect, useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useNavigate, useLocation } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import axios from "axios";
import { BaseURL } from "../../../../Files/BaseURL";
import EditSkill from "../../../../components/PopUp/EditSkill";
import EditProfile from "../../../../components/PopUp/EditProfile";
import GigsCart from "../../../../components/Dashboard/GigsCartPersonal";
import ThemeContext from "../../../../Context/theme/ThemeContext";
import BoostProfile from "../Adds/BoostProfile";
import { checkProfileAdd } from "../../../../Files/AddChecker";
import ConnectAccount from "../Withdraws/ConnectAccount";
import Swal from "sweetalert2";

const Profile = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const location = useLocation();
  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;

  const [User, setUser] = useState("");
  const [Profile, setProfile] = useState([]);
  const [Marketplace, setMarektplace] = useState([]);
  const [SkillModel, setSkillModel] = useState(false);
  const [ProfileModel, setProfileModel] = useState(false);
  const [BoostProfileSet, setBoostProfileSet] = useState(false);
  const [profileBoost, setProfileBoost] = useState(true);
  const [attachedAccount, setAttachedAccount] = useState(false);

  const fetchUser = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(`${BaseURL}/api/user/profile-detail`, {
        headers: {
          "Content-Type": "application/json",
          "auth-token": authToken,
        },
      });

      if (response.data) {
        setUser(response.data);
      } else {
        showAlert("No pending documents found", "info");
      }
    } catch (error) {
      showAlert("Error fetching pending documents", "danger");
    }
  };

  const deleteSkill = async (skillId) => {
    try {
      const authToken = localStorage.getItem("p@token");
      await axios.delete(`${BaseURL}/api/user/deletesubskill/${skillId}`, {
        headers: {
          "Content-Type": "application/json",
          "auth-token": authToken,
        },
      });
      fetchUser();
      showAlert("Skill deleted successfully", "success");
    } catch (error) {
      showAlert("Error deleting skill", "danger");
    }
  };

  const fetchPersonalProfile = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/portfolio/personal/fetchpersoanlportfolios`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
        }
      );

      if (response.data) {
        setProfile(response.data);
      } else {
        showAlert("No pending documents found", "info");
      }
    } catch (error) {
      showAlert("Error fetching pending documents", "danger");
    }
  };

  const fetchMarektProfile = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/portfolio/marketplace/fetchmarket`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
        }
      );

      if (response.data) {
        setMarektplace(response.data);
      } else {
        showAlert("No pending documents found", "info");
      }
    } catch (error) {
      showAlert("Error fetching pending documents", "danger");
    }
  };

  const deletePortfolio = async (portfolioId) => {
    try {
      const authToken = localStorage.getItem("p@token");
      await axios.delete(
        `${BaseURL}/api/portfolio/personal/delete/${portfolioId}`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
        }
      );
      fetchPersonalProfile();
      showAlert("Portfolio deleted successfully", "success");
    } catch (error) {
      showAlert("Error deleting portfolio", "danger");
    }
  };

  const fetchProfileCheck = async () => {
    const data = await checkProfileAdd();
    setProfileBoost(data);
  };

  useEffect(() => {
    fetchUser();
    fetchPersonalProfile();
    fetchMarektProfile();
    fetchProfileCheck();
  }, []);

  const createProductBoost = async (planId, requestId) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.post(
        `${BaseURL}/api/addSystem/addPayment/order-profile-status/${planId}/${requestId}`,
        {},
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );
      if (response.status === 200 || response.status === 202) {
        showAlert("Profile boosted successfully", "success");
      }
    } catch (error) {
      showAlert("Error boosting profile", "danger");
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("requestId") && params.get("planId")) {
      createProductBoost(params.get("planId"), params.get("requestId"));
    }
  }, [location.pathname]);

  const handlePlanChange = async (planId) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.post(
        `${BaseURL}/api/payment/change-plan/${planId}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
        }
      );

      if (response.data.success) {
        Swal.fire({
          title: "Success!",
          text: "Your plan has been changed successfully.",
          icon: "success",
          confirmButtonColor: "#3085d6",
        });
        // Refresh user data to show updated plan
        fetchUser();
      } else {
        throw new Error(response.data.message || "Failed to change plan");
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message || "Failed to change plan. Please try again.",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
    }
  };

  const showPlanChangeDialog = () => {
    Swal.fire({
      title: "Change Business Plan",
      html: `
        <div class="grid grid-cols-1 gap-4">
          <div class="p-4 border rounded-lg">
            <h3 class="font-bold text-lg">Basic Plan</h3>
            <p class="text-gray-600">$10/month</p>
            <button class="mt-2 px-4 py-2 bg-primarygreen text-white rounded-full" onclick="changePlan('basic_plan_id')">
              Select Plan
            </button>
          </div>
          <div class="p-4 border rounded-lg">
            <h3 class="font-bold text-lg">Premium Plan</h3>
            <p class="text-gray-600">$20/month</p>
            <button class="mt-2 px-4 py-2 bg-primarygreen text-white rounded-full" onclick="changePlan('premium_plan_id')">
              Select Plan
            </button>
          </div>
          <div class="p-4 border rounded-lg">
            <h3 class="font-bold text-lg">Enterprise Plan</h3>
            <p class="text-gray-600">$30/month</p>
            <button class="mt-2 px-4 py-2 bg-primarygreen text-white rounded-full" onclick="changePlan('enterprise_plan_id')">
              Select Plan
            </button>
          </div>
        </div>
      `,
      showConfirmButton: false,
      showCloseButton: true,
      didOpen: () => {
        window.changePlan = (planId) => {
          handlePlanChange(planId);
          Swal.close();
        };
      },
      willClose: () => {
        delete window.changePlan;
      },
    });
  };

  return (
    <>
      <EditSkill
        setSkillModel={setSkillModel}
        SkillModel={SkillModel}
        fetchUser={fetchUser}
      />
      <EditProfile
        setProfileModel={setProfileModel}
        ProfileModel={ProfileModel}
        fetchUser={fetchUser}
      />
      {BoostProfileSet && (
        <BoostProfile setBoostProfileSet={setBoostProfileSet} />
      )}
      <div
        className={`${attachedAccount ? "block" : "hidden"
          } fixed top-0 left-0 z-50 w-screen h-screen flex justify-center items-center`}
      >
        <div
          className="absolute w-full h-full bg-black/50 z-10"
          onClick={() => {
            setAttachedAccount(false);
          }}
        ></div>
        <ConnectAccount setConnect={setAttachedAccount} />
      </div>
      <div>
        <div
          className={` rounded-2xl my-6 w-[95%] m-auto py-6 px-6  ${theme == "dark" ? "bg-black text-white" : " bg-white"
            } `}
        >
          <div className="flex flex-col md:flex-row justify-between items-start">
            <div className="relative self-center">
              {User?.user?.ProfilePhoto ? (
                <div className="w-28 h-28 rounded-full overflow-hidden">
                  <img
                    src={User?.user?.ProfilePhoto}
                    alt=""
                    className="w-full h-full object-cover rounded-full"
                  />
                </div>
              ) : (
                <div className="w-28 h-28 rounded-full font-pop bg-gray-400 text-2xl flex items-center justify-center">
                  <span className="text-white">
                    {User?.user?.FirstName?.charAt(0)}
                  </span>
                </div>
              )}
            </div>
            <div
              className={`flex my-2 flex-col md:flex-row gap-2 md:items-center ${theme === "dark" && "text-white"
                }`}
            >
              <button
                className={` w-fit px-2 md:px-6 bg-green-500   hover:bg-white-500 font-semibold  font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full  text-white  ${theme === "dark" && "text-black"
                  }`}
                onClick={() => {
                  setAttachedAccount(true);
                }}
              >
                Attached Account
              </button>
              {!profileBoost && (
                <button
                  className={` w-fit px-2 md:px-6 bg-green-500   hover:bg-white-500 font-semibold  font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full  text-white  ${theme === "dark" && "text-black"
                    }`}
                  onClick={() => {
                    setBoostProfileSet(true);
                  }}
                >
                  Boost Profile
                </button>
              )}
              <button
                className={` w-fit px-2 md:px-6 bg-transparent hover:bg-primarygreen text-black hover:text-white font-semibold font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full ${theme === "dark" && "text-white"
                  }  `}
                onClick={() => {
                  if (User?.user?.BusinessAccount === "Approve") {
                    // For existing business users, navigate to pricing page
                    navigate("/business");
                  } else {
                    // For new users, navigate to business profile creation
                    navigate("/business");
                  }
                }}
              >
                {User?.user?.BusinessAccount === "Approve"
                  ? "Switch Business Plan"
                  : "Switch to business profile"}
              </button>
            </div>
          </div>
          <div className="flex flex-col gap-6 mt-6">
            <div className="flex font-pop flex-col gap-2">
              <h2 className="text-xl font-semibold">
                {User?.user?.FirstName} {User.user?.LastName}
              </h2>
              <p>
                {User?.user?.Homeaddress?.Address}{" "}
                {User?.user?.Homeaddress?.City} {User?.user?.Homeaddress?.State}
              </p>
            </div>
            <div className="flex font-pop flex-col gap-2">
              <div className="flex gap-2 items-center">
                <img
                  src="../../Assets/Prop/Mobile.png"
                  alt=""
                  className="w-6 h-6"
                />
                <p>+{User?.user?.Phone}</p>
              </div>
              <div className="flex gap-2 items-center">
                <img
                  src="../../Assets/Prop/Gmail.png"
                  alt=""
                  className="w-6 h-6 "
                />
                <p>{User?.user?.Email}</p>
              </div>
              <button
                className={`w-fit px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full  text-white 
                ${theme === "dark" && "hover:text-white"}`}
                onClick={() => {
                  setProfileModel(true);
                }}
              >
                Update Profile
              </button>
            </div>
            <div className="flex font-pop flex-col gap-2">
              <div className="flex gap-2 items-center">
                <h3
                  className={`text-lg text-lightGrey ${theme === "dark" && "text-white"
                    }`}
                >
                  Your Skills
                </h3>
                <p
                  className="text-primarygreen text-sm cursor-pointer"
                  onClick={() => {
                    setSkillModel(true);
                  }}
                >
                  Add new
                </p>
              </div>
              <div className="flex flex-wrap gap-2 items-center">
                {User?.Services?.map((item, index) => (
                  <div
                    className="flex gap-2 items-center bg-[#EFFBF1] border-2 border-primarygreen text-primarygreen py-1 px-4 rounded-2xl"
                    key={index}
                  >
                    {item?.name}
                    <IoCloseCircleOutline
                      className="text-lg cursor-pointer"
                      onClick={() => {
                        deleteSkill(item._id);
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="w-[95%] m-auto my-6 ">
          <p
            className={`text-lightGrey font-pop mb-4  ${theme === "dark" && "text-white"
              }`}
          >
            Portfolio
          </p>
          <div
            className={` rounded-2xl  py-6 px-6
          ${theme === "dark" ? "bg-black text-white" : "bg-white"}`}
          >
            <div className="flex flex-col  gap-6">
              <div
                className="flex items-center justify-center h-60 w-full"
                onClick={() => {
                  navigate("/user-dashboard/profile/create-portfolio");
                }}
              >
                <label
                  htmlFor="dropzone-file"
                  className={`flex flex-col h-full items-center justify-center w-full border-2 border-primarygreen border-dashed  rounded-lg cursor-pointer bg-transparen   ${theme === "dark" ? "bg-gray-700 text-white" : "bg-white"
                    }"`}
                >
                  <div className="flex flex-row gap-4 items-center justify-center py-3 text-primarygreen font-pop">
                    <IoIosAddCircleOutline className="text-2xl" />
                    <p
                      className={`text-base ${theme === "dark" && "text-white"
                        }`}
                    >
                      Upload project
                    </p>
                  </div>
                </label>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {Profile.map((item, index) => (
                  <div className="rounded-2xl relative" key={index}>
                    <img
                      src={item.Images}
                      alt=""
                      className="h-60 w-full rounded-2xl object-cover"
                    />
                    <div className="flex gap-2 items-center absolute z-20 justify-end top-2 right-2">
                      <div className="p-2 bg-white/25 rounded-xl">
                        <img
                          src="../../Assets/Prop/Edit.png"
                          alt=""
                          className="h-4 w-4 cursor-pointer"
                          onClick={() => {
                            navigate(
                              `/user-dashboard/profile/porfile_creation?editid=${item._id}`
                            );
                          }}
                        />
                      </div>
                      <div className="p-2 bg-white/25 rounded-xl">
                        <img
                          src="../../Assets/Prop/Delete.png"
                          alt=""
                          className="h-4 w-4 cursor-pointer"
                          onClick={() => {
                            deletePortfolio(item._id);
                          }}
                        />
                      </div>
                    </div>
                    <div className="bg-black/25 absolute bottom-0 w-full py-2 px-4 font-pop text-white">
                      <h2>{item.Title}</h2>
                    </div>
                  </div>
                ))}
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {Marketplace.map((item, index) => (
                  <>
                    <GigsCart
                      item={item}
                      key={index}
                      fetchMarektProfile={fetchMarektProfile}
                    />
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
